import React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { CoverSquare } from "../games/CoverImages";
import { useFilteredGamesByStatus } from "./useFilteredGamesByStatus";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").GameSummary[]} props.games - List of games to display
 * @param {import("@seabrookstudios/types").GameId[]} [props.selectedGames] - Currently selected game IDs (ignored when renderGame is provided)
 * @param {function(import("@seabrookstudios/types").GameId): void} [props.onToggleGame] - Callback when a game is toggled (ignored when renderGame is provided)
 * @param {import("@seabrookstudios/pitch2table-core").DesignerGameStatus[]} [props.defaultSelectedStatuses] - Default selected statuses
 * @param {(game: import("@seabrookstudios/pitch2table-core").GameSummary) => import("react").ReactNode} [props.renderGame] - Optional custom row renderer
 */
export const FilterableGamesList = ({
  games,
  selectedGames = [],
  onToggleGame = () => {},
  defaultSelectedStatuses = ["PitchingNow"],
  renderGame,
}) => {
  const { filteredGames, statusFilter } = useFilteredGamesByStatus(games, defaultSelectedStatuses);

  return (
    <>
      {statusFilter}
      <List>
        {filteredGames.map((game) =>
          renderGame ? (
            <React.Fragment key={game.id}>{renderGame(game)}</React.Fragment>
          ) : (
            <ListItemButton key={game.id} onClick={() => onToggleGame(game.id)}>
              <ListItemAvatar>
                <CoverSquare game={game} width={48} height={48} />
              </ListItemAvatar>
              <ListItemText primary={game.name} secondary={game.tag} />
              <ListItemIcon>{selectedGames.includes(game.id) && <CheckCircle color="success" />}</ListItemIcon>
            </ListItemButton>
          )
        )}
      </List>
      {filteredGames.length === 0 && (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <p>No games found.</p>
        </div>
      )}
    </>
  );
};
